import { Button, Icon } from "../../../components";
import { useEffect, useState, useCallback, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../../../layout/Dashboard";
import { currencyFormat } from "../../../utils/Formats";
import React from "react";
import { CardSelect, CupomModal, PaymentCard } from "../Forms";
import { Api } from "../../../api/Assinafy";
import PaymentProcessing from "../PaymentProcessing";
import { SessionContext } from "../../../routes/DashboardRoute"
import { getPaymentErrorMessage } from "../paymentErrors";

import "./styles.scss";

const plans = [
  { name: "Standard", max: 50, extra: 1, price: 39, period: "mês" },
  { name: "Pro", max: 200, extra: 0.5, price: 99, period: "mês" },
  { name: "Enterprise", max: 500, extra: 0.39, price: 199, period: "mês" },
  { name: "Free", max: 5, extra: null, price: "Grátis", period: "mês" },
];

const ExtraDocs = () => {
  const navigate = useNavigate();
  const isMountedRef = useRef(true);
  const timeoutRef = useRef(null);
  const [session] = useContext(SessionContext)
  
  const { user } = session || { user: {} }
  const [modal, setModal] = useState(false);
  const [docAmount, setDocAmount] = useState(10);

  const [loadingCards, setLoadingCards] = useState(true);
  const [creditCards, setCreditCards] = useState([]);
  const [paymentData, setPaymentData] = useState({
    isNewCard: true,
    selectedCardId: null,
    newCardData: {},
    isNewCardValid: false,
  });
  const [forceValidation, setForceValidation] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const [currentPlan, setCurrentPlan] = useState(null);
  const [needsCustomerUpdate, setNeedsCustomerUpdate] = useState(false);

  const [discount, setDiscount] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountName, setDiscountName] = useState("feba10");

  const [Total, setTotal] = useState(0);
  const userName = user?.name || "Usuário"

  const changeDocAmount = (i) => {
    const newAmount = docAmount + i;
    if (newAmount >= 1) {
      setDocAmount(newAmount);
    }
  };

  const price = currentPlan?.extra_document_price || plans[0].extra;

  const summaryText = "Resumo de valores";

  const fetchSubscriptionData = async () => {
    try {
      const response = await Api("subscription/view")();
      
      if (!isMountedRef.current) return;

      if (response?.status === 200 && response?.data?.data) {
        setCurrentPlan(response.data.data);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do plano:", error);
    }
  };

  const fetchCreditCards = async () => {
    try {
      setLoadingCards(true);
      const response = await Api("creditCard/index")();

      if (!isMountedRef.current) return;

      if (response?.status === 200 && response?.data?.data) {
        setCreditCards(response.data.data);
        if (response.data.data.length > 0) {
          setPaymentData({
            isNewCard: false,
            selectedCardId: response.data.data[0].id,
            newCardData: {},
            isNewCardValid: false,
          });
        }
      } else {
        setCreditCards([]);
      }
    } catch (error) {
      console.error("Erro ao buscar cartões:", error);
      if (isMountedRef.current) {
        setCreditCards([]);
      }
    } finally {
      if (isMountedRef.current) {
        setLoadingCards(false);
      }
    }
  };

  const fetchCustomerData = async () => {
    try {
      const response = await Api("customer/view")();

      if (!isMountedRef.current) return;

      if (response?.status === 200 && response?.data?.data) {
        const customer = response.data.data;
        const requiredFields = ["name", "email", "taxpayer_id", "postal_code", "address_line1", "city", "state"];
        const missingFields = requiredFields.filter((field) => !customer[field]);

        if (missingFields.length > 0) {
          setNeedsCustomerUpdate(true);
        }
      } else {
        setNeedsCustomerUpdate(true);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do cliente:", error);
      if (isMountedRef.current) {
        setNeedsCustomerUpdate(true);
      }
    }
  };

  const updateCustomerData = async (cardData) => {
    try {
      const customerPayload = {
        name: cardData.holder_name,
        taxpayer_id: cardData.holder_taxpayer_id.replace(/\D/g, ""),
        phone_number: cardData.holder_phone.replace(/\D/g, ""),
        email: cardData.holder_email,
        address: {
          line1: cardData.address_line1,
          line2: cardData.address_line2 || "",
          house_number: cardData.house_number,
          neighborhood: cardData.neighborhood,
          city: cardData.city,
          state: cardData.state,
          postal_code: cardData.postal_code.replace(/\D/g, ""),
        },
      };

      const response = await Api("customer/update")(customerPayload);

      if (!isMountedRef.current) return false;

      if (response?.status === 200) {
        setNeedsCustomerUpdate(false);
        return true;
      } else {
        throw new Error("Erro ao atualizar dados do cliente");
      }
    } catch (error) {
      console.error("Erro ao atualizar dados do cliente:", error);
      throw error;
    }
  };

  const handlePurchaseExtraDocs = async () => {
    if (isProcessing) return;

    if (!paymentData.isNewCard && !paymentData.selectedCardId) {
      alert("Por favor, selecione um cartão ou adicione um novo.");
      return;
    }

    if (paymentData.isNewCard && !paymentData.isNewCardValid) {
      setForceValidation(true);
      return;
    }

    try {
      setIsProcessing(true);
      setForceValidation(false);
      setErrorMessage(null);
      setPaymentStatus("processing");

      if (paymentData.isNewCard && paymentData.newCardData) {
        const cardData = paymentData.newCardData;

        if (needsCustomerUpdate) {
          await updateCustomerData(cardData);
        }

        const creditCardPayload = {
          number: cardData.number.replace(/\s/g, ""),
          name_on_card: cardData.name_on_card,
          expiration_month: parseInt(cardData.expiration_month),
          expiration_year: parseInt(cardData.expiration_year),
          security_code: parseInt(cardData.security_code),
          holder: {
            name: cardData.holder_name,
            email: cardData.holder_email,
            taxpayer_id: cardData.holder_taxpayer_id.replace(/\D/g, ""),
            postal_code: cardData.postal_code.replace(/\D/g, ""),
            address_line1: cardData.address_line1,
            address_line2: cardData.address_line2 || "",
            house_number: cardData.house_number,
            phone_number: cardData.holder_phone.replace(/\D/g, ""),
            neighborhood: cardData.neighborhood,
            city: cardData.city,
            state: cardData.state,
          },
        };

        const cardResponse = await Api("creditCard/create")(creditCardPayload);

        if (cardResponse?.status !== 200) {
          throw new Error(cardResponse?.data?.message || "Erro ao criar cartão de crédito");
        }
      }

      const purchasePayload = {
        items: [
          {
            type: "document",
            quantity: docAmount
          }
        ]
      };

      if (!paymentData.isNewCard && paymentData.selectedCardId) {
        purchasePayload.credit_card_id = paymentData.selectedCardId;
      } else if (paymentData.isNewCard && paymentData.newCardData) {
        const cardData = paymentData.newCardData;
        purchasePayload.credit_card = {
          number: cardData.number.replace(/\s/g, ""),
          name_on_card: cardData.name_on_card,
          expiration_month: parseInt(cardData.expiration_month),
          expiration_year: parseInt(cardData.expiration_year),
          security_code: parseInt(cardData.security_code),
          holder: {
            name: cardData.holder_name,
            email: cardData.holder_email,
            taxpayer_id: cardData.holder_taxpayer_id.replace(/\D/g, ""),
            postal_code: cardData.postal_code.replace(/\D/g, ""),
            address_line1: cardData.address_line1,
            address_line2: cardData.address_line2 || "",
            house_number: cardData.house_number,
            phone_number: cardData.holder_phone.replace(/\D/g, ""),
            neighborhood: cardData.neighborhood,
            city: cardData.city,
            state: cardData.state,
          },
        };
      }

      if (discount && discountName) {
        purchasePayload.coupon_code = discountName;
      }

      const response = await Api("credit/purchase")(purchasePayload);

      if (!isMountedRef.current) return;

      if (response?.status === 200) {
        setPaymentStatus("success");
        timeoutRef.current = setTimeout(() => {
          if (isMountedRef.current) {
            navigate("/dashboard/workspace/plan");
          }
        }, 3000);
      } else {
        throw new Error("Erro ao comprar documentos extras");
      }
    } catch (error) {
      console.error("Erro no pagamento:", error);
      if (isMountedRef.current) {
        setErrorMessage(getPaymentErrorMessage(error, "Não foi possível comprar os documentos extras."));
        setPaymentStatus("failure");
      }
    } finally {
      if (isMountedRef.current) {
        setIsProcessing(false);
      }
    }
  };

  const handleFormChange = useCallback((data) => {
    setPaymentData({
      isNewCard: true,
      selectedCardId: null,
      newCardData: data.formData,
      isNewCardValid: data.isValid,
    });
  }, []);

  const handleReturnFromProcessing = () => {
    if (paymentStatus === "success") {
      navigate("/dashboard/workspace");
    } else if (paymentStatus === "failure") {
      setPaymentStatus(null);
      setForceValidation(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionData();
    fetchCreditCards();
    fetchCustomerData();

    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let total = docAmount * price;
    if (discount && discountAmount) {
      total += discountAmount;
    }
    setTotal(Math.max(0, total));
  }, [docAmount, discount, discountAmount, price]);

  if (paymentStatus) {
    return <PaymentProcessing state={paymentStatus} data={{ total: Total, name: userName, errorMessage }} onReturn={handleReturnFromProcessing} />;
  }

  return (
    <Dashboard.Content style={{ maxWidth: "688px" }}>
      <Dashboard.Header
        returnButton={true}
        title="Comprando documentos extras"
        className="d-flex reverse-row"
      />
      <PaymentCard
        className="extraDocs-card"
        topcontent={
          <>
            <div>
              <h2>Documentos extras</h2>
              <p>Valor unitário {currencyFormat(price)}</p>
            </div>
            <div className="extraDocs-stepper">
              <Button onClick={() => changeDocAmount(-1)} disabled={docAmount <= 1}>
                <Icon id="icon-minus" />
              </Button>
              <div>{docAmount}</div>
              <Button onClick={() => changeDocAmount(+1)}>
                <Icon id="icon-plus" />
              </Button>
            </div>
          </>
        }
        middlecontent={
          <>
            <>
              {/* {discount ? (
                <div>
                  <p>
                    Cupom aplicado:{" "}
                    <span className="fw-500">{discountName}</span>
                  </p>
                  <Button variant="link" className="cupom-button" onClick={() => setModal(true)}>
                    Trocar <span className="d-none d-lg-inline">cupom</span>
                  </Button>
                </div>
              ) : (
                <div>
                  <p>Cupom de desconto</p>
                  <Button
                    variant="link"
                    className="cupom-button"
                    onClick={() => setModal(true)}
                  >
                    Adicionar cupom
                  </Button>
                </div>
              )} */}
            </>
            <div className="payment-summaryRow">
              <p className="payment-summaryRow-title">Resumo de valores</p>
              <p className="payment-summaryRow-date">{summaryText}</p>
            </div>
            <div className="payment-amountBox">
              <p>Documentos extras</p>
              <div className="payment-amountBox-inner">
                <div>Quant. {`${docAmount}`}</div>
                <div className="fw-500">
                  {currencyFormat(docAmount * price)}
                </div>
              </div>
            </div>
            {/* <>
              {discount && (
                <div>
                  <p>Cupom</p>
                  <div className="fw-500">{currencyFormat(discountAmount)}</div>
                </div>
              )}
            </> */}
          </>
        }
        total={Total}
      />
      <h3>
        {loadingCards
          ? "Carregando..."
          : creditCards.length > 0
            ? "Escolha como pagar"
            : "Insira os dados do cartão"}
      </h3>
      <div className="card-select pb-3">
        {loadingCards ? (
          <div className="text-center p-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        ) : (
          <CardSelect 
            creditCards={creditCards} 
            onCardSelect={setPaymentData} 
            onFormChange={handleFormChange}
            forceValidation={forceValidation} 
          />
        )}
      </div>
      <div className="d-flex w-100 mt-3 justify-content-end">
        <Button 
          variant="primary" 
          className="text-uppercase btn-wide btn-responsive"
          onClick={handlePurchaseExtraDocs}
          disabled={isProcessing || (!paymentData.isNewCard && !paymentData.selectedCardId)}
        >
          {isProcessing ? "Processando..." : "Comprar"}
        </Button>
      </div>
      <CupomModal
        show={modal}
        onClose={() => setModal(false)}
        cupom={discountName}
        setCupomName={setDiscountName}
        setCupom={setDiscount}
        setCupomValue={setDiscountAmount}
      />
    </Dashboard.Content>
  );
};

export default ExtraDocs;
